import { render } from "./MiniCalendarAsBox.vue?vue&type=template&id=ebd2a160&scoped=true&ts=true"
import script from "./MiniCalendarAsBox.vue?vue&type=script&lang=ts"
export * from "./MiniCalendarAsBox.vue?vue&type=script&lang=ts"

import "./MiniCalendarAsBox.vue?vue&type=style&index=0&id=ebd2a160&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd2a160"]])

export default __exports__